import { useEffect, Dispatch, SetStateAction } from 'react';
import { cannedResponseApi } from '../services/cannedResponseApi';
import { getCannedResponseBody } from '../utils/cannedResponseI18n';

/** Inserts canned text after existing draft, adding a space only when needed. */
export function appendCannedResponseContent(prev: string, content: string): string {
  const prefix = prev.endsWith(' ') || prev === '' ? '' : ' ';
  return prev + prefix + content;
}

/**
 * When the composer contains only a registered shortcut followed by a space
 * (e.g. `/greet ` for English or `/greet_ar ` for Arabic), replace it with the matching body.
 */
export function useCannedResponseShortcuts(
  message: string,
  setMessage: Dispatch<SetStateAction<string>>
): void {
  useEffect(() => {
    const run = async () => {
      const shortcutMatch = message.match(/^(\/[^\s]+)\s$/);
      if (!shortcutMatch) return;
      const shortcut = shortcutMatch[1];
      const match = await cannedResponseApi.searchByShortcut(shortcut);
      if (match) {
        const body = getCannedResponseBody(match.response, match.language);
        setMessage(body + ' ');
        await cannedResponseApi.incrementUsage(match.response.id);
      }
    };
    run();
  }, [message, setMessage]);
}
